import { Container, Heading, Box, ContainerProps } from '@hover/blueprint';
import React from 'react';

interface Props extends ContainerProps {
  numberOfSlides: number;
}

const HoInvitedBetterWayToBuildContainer: React.FC<Props> = ({
  children,
  numberOfSlides,
  ...restProps
}) => (
  <Container
    maxW="8xl"
    d="flex"
    alignItems="flex-start"
    justifyContent="center"
    {...restProps}
  >
    <Box
      d="flex"
      flexDir="column"
      alignItems="flex-start"
      justifyContent="flex-start"
      position="sticky"
      top="110px"
      h={{ base: 'auto', desktop: '100vh' }}
      maxW={{ base: '100%' }}
    >
      <Container alignItems="center" mb="56px" maxW="4xl" px={200}>
        <Heading
          maxW="4xl"
          marginBottom={500}
          size={{ base: 500, tablet: 700 }}
          textAlign="center"
          isLight
        >
          We’re simplifying the claims process.
        </Heading>
        <Heading size={{ base: 200, tablet: 500 }} isDisplay textAlign="center">
          Your insurance company is using HOVER to make completing your claim
          easier. A little of your time and your phone is all you need.
        </Heading>
      </Container>
      {children}
    </Box>
    <Box
      w={0}
      height={{ base: 0, desktop: `${(numberOfSlides + 1) * 100}vh` }}
      id="build-container"
    />
  </Container>
);

export default HoInvitedBetterWayToBuildContainer;
